import { Interval } from '@zapier/design-system-revenue/src/types';

export const buildDowngradeTeamWarningUrl = (
  fromPlanName: string,
  toPlanName: string,
  interval: Interval
): string =>
  encodeURI(
    `/app/billing/plans/downgrade-team/${fromPlanName.toLocaleLowerCase()}/${toPlanName.toLocaleLowerCase()}/${interval}`
  );
